<template>
    <div
        element-loading-background="rgba(0, 0, 0, 0.08)"
        class="not-found">
        404, <a href="javascript: history.back();">返回</a>
    </div>
</template>
<script>
export default {
    name: 'NotFoundPage',
    data()
    {
        return {
        }
    }
}
</script>
<style>
    .not-found
    {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/NotFoundPage.vue